var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0001 14.4C9.69748 14.4 11.3253 13.7257 12.5256 12.5255C13.7258 11.3253 14.4001 9.69739 14.4001 8.00001C14.4001 6.30262 13.7258 4.67476 12.5256 3.47452C11.3253 2.27429 9.69748 1.60001 8.0001 1.60001C6.30271 1.60001 4.67485 2.27429 3.47461 3.47452C2.27438 4.67476 1.6001 6.30262 1.6001 8.00001C1.6001 9.69739 2.27438 11.3253 3.47461 12.5255C4.67485 13.7257 6.30271 14.4 8.0001 14.4ZM8.5657 6.16561C8.71142 6.01472 8.79206 5.81264 8.79024 5.60289C8.78841 5.39313 8.70428 5.19248 8.55595 5.04415C8.40763 4.89582 8.20698 4.81169 7.99722 4.80987C7.78746 4.80804 7.58538 4.88868 7.4345 5.03441L5.0345 7.43441C4.88452 7.58443 4.80027 7.78787 4.80027 8.00001C4.80027 8.21214 4.88452 8.41558 5.0345 8.56561L7.4345 10.9656C7.58538 11.1113 7.78746 11.192 7.99722 11.1901C8.20698 11.1883 8.40763 11.1042 8.55595 10.9559C8.70428 10.8075 8.78841 10.6069 8.79024 10.3971C8.79206 10.1874 8.71142 9.98529 8.5657 9.83441L7.5313 8.80001H10.4001C10.6123 8.80001 10.8158 8.71572 10.9658 8.56569C11.1158 8.41566 11.2001 8.21218 11.2001 8.00001C11.2001 7.78783 11.1158 7.58435 10.9658 7.43432C10.8158 7.28429 10.6123 7.20001 10.4001 7.20001H7.5313L8.5657 6.16561Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleLeft);
export default __webpack_public_path__ + "static/media/ArrowCircleLeft.9d3ca1d8ae4f6f53e3b334da7550d6be.svg";
export { ForwardRef as ReactComponent };